export default {
  performRed: '#D34216',
  ibacosBlue: '#1f386f',
};
